export default "__VITE_ASSET__71de35aa__"